import { Insertion, insertionsEqual } from '@paragon/contract-library';

export type InsertionChangeTracker = { created: Insertion[]; removed: Insertion[] };

export function createInsertionChangeTracker(): InsertionChangeTracker {
  return { created: [], removed: [] };
}

export function recordInsertionCreation(tracker: InsertionChangeTracker, insertion: Insertion, quantity = 1) {
  for (let i = 0; i < quantity; i += 1) {
    const insertionRemovalIndex = tracker.removed.findIndex(equalTo(insertion));

    if (insertionRemovalIndex !== -1) {
      tracker.removed.splice(insertionRemovalIndex, 1);
    } else {
      tracker.created.push({ ...insertion });
    }
  }
}

export function recordInsertionRemoval(tracker: InsertionChangeTracker, insertion: Insertion, quantity = 1) {
  for (let i = 0; i < quantity; i += 1) {
    const insertionCreationIndex = tracker.created.findIndex(equalTo(insertion));

    if (insertionCreationIndex !== -1) {
      tracker.created.splice(insertionCreationIndex, 1);
    } else {
      tracker.removed.push({ ...insertion });
    }
  }
}

export function recordInsertionSynchronized(tracker: InsertionChangeTracker, insertion: Insertion) {
  for (const source of [tracker.created, tracker.removed]) {
    const index = source.findIndex(equalTo(insertion));

    if (index !== -1) {
      source.splice(index, 1);
      return;
    }
  }
}

export function hasModifiedInsertions(tracker: InsertionChangeTracker) {
  return tracker.created.length > 0 || tracker.removed.length > 0;
}

const equalTo = (insertion: Insertion) => (other: Insertion) => insertionsEqual(insertion, other);
